import { render, staticRenderFns } from "./AttorneyPage.vue?vue&type=template&id=47f6fb5d&scoped=true&"
import script from "./AttorneyPage.vue?vue&type=script&lang=js&"
export * from "./AttorneyPage.vue?vue&type=script&lang=js&"
import style0 from "./AttorneyPage.vue?vue&type=style&index=0&id=47f6fb5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6fb5d",
  null
  
)

export default component.exports